import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function FloatingWhatsAppButton() {
  return (
    <a
      href={COMPANY.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-success rounded-full flex items-center justify-center shadow-whatsapp animate-pulse-whatsapp transition-transform duration-300 hover:scale-110 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-graphite text-white text-xs font-body font-medium px-3 py-1.5 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden md:block">
        WhatsApp Us
      </span>
    </a>
  );
}
